import type { CustomerOrder } from '../../customerOrdersApi'
import type { CustomerProfile } from '../../types'
import type { ShopLocale } from '../../../i18n'
import { EMAIL_REGEX, parseTimestamp, TAX_CODE_REGEX, type BillingFormState } from './preferencesShared'

export const buildBillingDefaults = (profile: CustomerProfile): BillingFormState => ({
  firstName: profile.firstName || '',
  lastName: profile.lastName || '',
  taxCode: profile.taxCode || '',
  phone: profile.phone || '',
  billingEmail: profile.email || '',
})

export const resolveAssociatedAddress = (profile: CustomerProfile) => {
  const billing = profile.billingAddress.trim()
  const shipping = profile.shippingAddress.trim()
  const residential = profile.residentialAddress.trim()
  return billing || shipping || residential || ''
}

export const resolveLatestPaymentOrder = (orders: CustomerOrder[]) => {
  if (!orders.length) return null
  return (
    [...orders]
      .filter((order) => Boolean(order.paidAt))
      .sort((left, right) => parseTimestamp(right.paidAt) - parseTimestamp(left.paidAt))[0] || null
  )
}

export const createDateFormatter = (locale: ShopLocale) =>
  new Intl.DateTimeFormat(locale, {
    dateStyle: 'medium',
  })

export const resolveLatestPaymentDate = (dateFormatter: Intl.DateTimeFormat, paidAt: string | null) => {
  if (!paidAt) return '-'
  const parsed = new Date(paidAt)
  if (Number.isNaN(parsed.getTime())) return '-'
  return dateFormatter.format(parsed)
}

export const normalizeTaxCode = (taxCode: string) => taxCode.replace(/\s+/g, '').toUpperCase()

export const normalizeBillingEmail = (billingEmail: string) => billingEmail.trim()

export const isTaxCodeInvalid = (normalizedTaxCode: string) =>
  normalizedTaxCode.length > 0 && !TAX_CODE_REGEX.test(normalizedTaxCode)

export const isBillingEmailInvalid = (normalizedBillingEmail: string) =>
  normalizedBillingEmail.length > 0 && !EMAIL_REGEX.test(normalizedBillingEmail)

export const resolveAssociatedName = (billingFormState: BillingFormState) =>
  [billingFormState.firstName.trim(), billingFormState.lastName.trim()].filter(Boolean).join(' ').trim()
